import React from 'react';
import classNames from 'classnames';

import css from './IconLifestyleAndGiftShop.module.css';

export const IconLifestyleAndGiftShop = ({ rootClassName, className }) => {
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
      <path
        fill="#011602"
        d="M62 25a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1H46.949a14.981 14.981 0 0 0-29.9 0H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h1v32H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h60a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1V25Zm-1-2H45.256a14.878 14.878 0 0 0 1.693-6H61ZM32 3a13 13 0 1 1-13 13A13.015 13.015 0 0 1 32 3ZM3 17h14.051a14.878 14.878 0 0 0 1.693 6H3Zm58 44H3v-2h58Zm-38-4H9V35h14Zm36 0H25V34a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v23H5V25h15.028a14.944 14.944 0 0 0 23.944 0H59Z"
      />
      <path
        fill="#011602"
        d="M25 17v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2.586l2.293-2.293a1 1 0 0 0-.152-1.539l-3-2a1 1 0 0 0-1.45.385L32 9.764l-2.1-4.211a1 1 0 0 0-1.45-.385l-3 2a1 1 0 0 0-.152 1.539L27.586 11H25a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1Zm2 0h2v6h-2Zm7-4v2h-4v-2Zm-1 4v6h-2v-6Zm4 6h-2v-6h2Zm1-8h-2v-2h2Zm-2.612-7.54 1.042.695-2.78 2.781Zm-6.776 0 1.738 3.476-2.78-2.781ZM26 13h2v2h-2ZM28 33a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h28a1 1 0 0 0 1-1V34a1 1 0 0 0-1-1Zm27 14H29v-2.586L38.414 35h4.172l-5.293 5.293 1.414 1.414L45.414 35H55ZM35.586 35 29 41.586V35ZM29 51v-2h26v2Z"
      />
      <path fill="#011602" d="m34.293 43.292 2-2 1.414 1.415-2 2zM11 43h2v4h-2z" />
    </svg>
  );
};

export default IconLifestyleAndGiftShop;
